module.exports = __webpack_public_path__ + "static/media/login-Image-new.b713cf6a.png";